/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 * @author Nikolay Sviridov
 * @version 1.35.0
 * @since 1.35.0
 */

export const paymentStringWithComma = (amount: number, currency: string, afterCurrencyText?: string) => {
	const amountAsString = amount.toString().replace(/\./g, ',');
	return `${amountAsString} ${currency} ${afterCurrencyText ?? ''}`;
};
